import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AppProvidersLayout from '../components/Layouts/AppProvidersLayout';
// import Home from '../pages/market/MarketPage';
// import NotFound from '../pages/info/NotFound';
// import ListingPage from '../pages/ListingPage';
// import AdsLandingPage from '../pages/AdsLandingPage';
// import AdsAgentLandingPage from '../pages/AdsAgentLandingPage';
// const HomePage = lazy(() => import('../pages/HomePage'));
const Market = lazy(() => import('../pages/market/MarketPage'));
const NotFound = lazy(() => import('../pages/info/NotFound'));
const ListingPage = lazy(() => import('../pages/ListingPage'));
const AdsLandingPage = lazy(() => import('../pages/AdsLandingPage'));
const AdsAgentLandingPage = lazy(() => import('../pages/AdsAgentLandingPage'));
// import CommunityPage from '../pages/community/CommunityPage';
// import SquarePage from '../pages/square/SquarePage';
// import PostPage from '../components/square/PostPage';
import Layout from '../components/Layouts/Layout';
import { RouteErrorBoundary } from '../ErrorBoundary/RouteErrorBoundary';

import { withoutLayoutRoutes } from './WithoutLayoutRoutes';
import { layoutRoutes } from './LayoutRoutes';
import { adminRoutes } from './AdminRoutes';
import { wlRoutes } from './WLRoutes';
import { helpRoutes } from './HelpRoutes';
import { dashboardRoutes } from './DashboardRoutes';
import { businessRoutes } from './BusinessRoutes';
import Loader from '../components/main/Loader';

function Router() {
  const mainLayoutRoutes = [
    {
      element: <Layout />, // Layout wrapper
      children: [
        { path: '/properties/:id/:title?', element: <ListingPage /> },
        { path: '/homes/:country/:city/:title/:id', element: <ListingPage /> },
        { path: '/property-search/thailand', element: <AdsLandingPage type="th" /> },
        { path: '/property-search/sri-lanka', element: <AdsLandingPage type="sl" /> },
        { path: '/list-property/thailand', element: <AdsAgentLandingPage type="th" /> },
        { path: '/list-property/sri-lanka', element: <AdsAgentLandingPage type="sl" /> },
        // { path: '/community', element: <CommunityPage /> },
        // { path: '/square', element: <SquarePage /> },
        // { path: '/square/post/:postId/:title?', element: <PostPage /> },
        { path: '/market', element: <Market /> },
        { path: '/', element: <Market /> },
      ],
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ];
  const router = createBrowserRouter([
    {
      path: '/',
      element: <AppProvidersLayout />,
      errorElement: <RouteErrorBoundary />,
      children: [
        // all your routes go here
        ...mainLayoutRoutes,
        ...wlRoutes,
        ...layoutRoutes,
        ...helpRoutes,
        ...dashboardRoutes,
        ...adminRoutes,
        ...businessRoutes,
        ...withoutLayoutRoutes,
      ],
    },
  ]);

  return (
    <Suspense
      fallback={
        <div className="text-gray-500 flex w-full h-[100vh] p-6 items-center justify-center flex-col space-y-8">
          <Loader />
          <div className="animate-pulse">Loading...</div>
        </div>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default Router;
